var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ContentStepper from "./content-stepper";
export default function ContentSection(_a) {
    var title = _a.title, subtitle = _a.subtitle, steps = _a.steps;
    return (_jsxs("section", __assign({ className: "w-full flex flex-col space-y-4" }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-2" }, { children: [_jsx("h2", __assign({ className: "font-semibold text-xl text-[#022A59]" }, { children: title })), _jsx("h3", __assign({ className: "text-[#404040] text-base tracking-wide" }, { children: subtitle }))] })), _jsx(ContentStepper, { steps: steps })] })));
}
